"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/**
 * Experimental decorator that marks classes as
 * implementing static methods and/or members
 */
function staticImplements() {
    return function (consructor) { };
}
exports.staticImplements = staticImplements;
/* tslint:enable */
//# sourceMappingURL=getterConfig.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/config/getterConfig.js
 ** module id = 2470
 ** module chunks = 0
 **/